import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import { Button, Divider } from '@mui/material';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import MuiAlert from '@mui/material/Alert';
import Paper from '@mui/material/Paper';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import useConfiguration from './Configuration.services';
import OccupationsCatalog from '../occupations/OccupationsCatalog';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Configuration = () => {

  const {
    configurationDetail,
    getConfiguration,
    updateAgenteCapacitador,
    updateAgenteCapacitadorRfc,
    updateSuccess,
    updateFailure,
    saveConfiguration,
    originalDataChanged,
    handleClose,
  } = useConfiguration();

  useEffect(() => {
    getConfiguration();
  }, []);

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[900],
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
      }}
    >
      <Toolbar />
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h6" gutterBottom>
                Configuración general
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    id="agente_capacitador"
                    name="agente_capacitador"
                    label="Agente capacitador"
                    fullWidth
                    autoComplete="off"
                    variant="standard"
                    value={configurationDetail.agente_capacitador ?? ""}
                    onChange={(event) => {
                      updateAgenteCapacitador(event.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="agente_capacitador_rfc"
                    name="agente_capacitador_rfc"
                    label="RFC / Registro del agente capacitador"
                    fullWidth
                    autoComplete="off"
                    variant="standard"
                    value={configurationDetail.agente_capacitador_rfc ?? ""}
                    onChange={(event) => {
                      updateAgenteCapacitadorRfc(event.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Divider />
                  <Button
                    disabled={!originalDataChanged}
                    variant="contained"
                    sx={{ mt: 3, ml: 1 }}
                    onClick={() => { saveConfiguration() }}
                  >
                    Actualizar
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <OccupationsCatalog />
          </Grid>
        </Grid>
      </Container>
      <Snackbar open={updateSuccess} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
          Configuración actualizada
        </Alert>
      </Snackbar>
      <Snackbar open={updateFailure} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
          Error, no se pudo actualizar la configuración
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Configuration;
